import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Header,
  Nav,
  ProductTableItem,
  SearchInput,
} from "../styles";
import GoBackButton from "../../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../../components/badges";
import { useDispatch, useSelector } from "react-redux";
import { getContractProducts } from "../../../../../redux/modules/staff-acess/actions";
import { ContractProductsContainer, ContractProductsTitle } from "./styles";
import ProductInfo, { ProductInfoSkeleton } from "../components/ProductInfo";
import { FormattedMessage, useIntl } from "react-intl";
import SearchIcon from "../../../components/Icons/search-icon";
import { Empty } from "../components/Empty";

export default function ContractProducts() {
  const intl = useIntl();
  const fantasyname = localStorage.getItem("serviceFantasyname");
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const systemUserId = localStorage.getItem("serviceSystemUserId");
  const { contractProducts, contractProductsLoaded } = useSelector(
    (state) => state.staff_access
  );
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (contractNumber && !contractProductsLoaded) {
      dispatch(getContractProducts({ contractNumber, systemUserId }));
    }
  }, [dispatch, contractNumber, contractProductsLoaded]);

  const prods = useMemo(() => {
    if (search) {
      const searchedTerm = search.toLowerCase().trim();

      return contractProducts.filter((p) =>
        p?.productName?.toLowerCase().includes(searchedTerm)
      );
    }
    return contractProducts;
  }, [search, contractProducts]);

  return (
    <Container>
      <Nav>
        <GoBackButton
          noPosition
          href={"/staff-access/services/sales"}
          intlId="backToDashboard"
        />

        <FantasyNameAndContractBadge
          fantasyname={fantasyname}
          contractNumber={contractNumber}
        />
      </Nav>

      <Header>
        <ContractProductsTitle>
          <span>
            <FormattedMessage id={"sales"} />
            {" /"}
          </span>
          <h2>
            {" "}
            {search.length === 0 && (
              <FormattedMessage id={"contractProducts"} />
            )}
            {search.length > 0 && (
              <>
                <FormattedMessage id={"searchResult"} /> "
                <span title={search}>{search}</span>"
              </>
            )}
          </h2>
        </ContractProductsTitle>
        <SearchInput
          prefix={<SearchIcon />}
          placeholder={intl.formatMessage({
            id: "search",
          })}
          allowClear
          onChange={(e) => setSearch(e.target.value)}
        />
      </Header>

      <ContractProductsContainer>
        {!contractProductsLoaded &&
          Array.from({ length: 50 }).map((p, i) => (
            <ProductTableItem
              first
              key={i}
              style={{
                animation: "fadeIn 0.5s ease-in-out",
                opacity: 1,
              }}
            >
              <ProductInfoSkeleton />
            </ProductTableItem>
          ))}
        {prods.length === 0 && contractProductsLoaded && <Empty />}
        {prods.length > 0 &&
          contractProductsLoaded &&
          prods.map((p, i) => {
            return (
              <ProductTableItem
                first
                key={i}
                style={{
                  animation: "fadeIn 0.5s ease-in-out",
                  opacity: 1,
                }}
              >
                <ProductInfo
                  descMoreLines={false}
                  desc={p.productDescription}
                  name={
                    p.productName ??
                    intl.formatMessage({ id: "nameless_product" })
                  }
                  qtd={p.quantity}
                  src={null}
                  showQtd
                />
              </ProductTableItem>
            );
          })}
      </ContractProductsContainer>
    </Container>
  );
}
